'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FilterBar = require('../../FilterBar/components/FilterBar');

var _FilterBar2 = _interopRequireDefault(_FilterBar);

var _ActivityTableContainer = require('../../ActivityTable/containers/ActivityTableContainer');

var _ActivityTableContainer2 = _interopRequireDefault(_ActivityTableContainer);

require('./Activity.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Activity = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Activity, _Component);

  function Activity() {
    (0, _classCallCheck3.default)(this, Activity);
    return (0, _possibleConstructorReturn3.default)(this, (Activity.__proto__ || (0, _getPrototypeOf2.default)(Activity)).apply(this, arguments));
  }

  (0, _createClass3.default)(Activity, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'Activity__Component' },
        _react2.default.createElement(_FilterBar2.default, {
          filters: this.props.filters,
          aggregateEventUpdateAvailable: this.props.aggregateEventUpdateAvailable,
          createAction: this.props.createAction
        }),
        _react2.default.createElement(_ActivityTableContainer2.default, null)
      );
    }
  }]);
  return Activity;
}(_react.Component), _class.propTypes = {
  createAction: _propTypes2.default.func.isRequired,
  filters: _propTypes2.default.shape({
    searchTerm: _propTypes2.default.string,
    filterRange: _propTypes2.default.string,
    startTime: _propTypes2.default.object,
    endTime: _propTypes2.default.object,
    lastNdays: _propTypes2.default.number
  }).isRequired,
  aggregateEventUpdateAvailable: _propTypes2.default.bool.isRequired
}, _temp);
exports.default = Activity;


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/dear-diary/lib/modules/Activity/components/Activity.js
// module id = 3415
// module chunks = 2